import { Link, router } from '@inertiajs/react'
import { usePage } from '@inertiajs/react'
import Flash from '@/components/ui/Flash'
import { Search } from 'lucide-react'
import { useState } from 'react'
import type { SharedProps } from '@/types'

export default function Navbar() {
  const { auth } = usePage<SharedProps>().props
  const [query, setQuery] = useState('')

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    if (query.trim()) router.get('/search', { q: query })
  }

  return (
    <>
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center gap-4">
        {/* Logo */}
        <Link href="/" className="font-bold text-xl text-gray-900 shrink-0">
          GetCasts
        </Link>

        {/* Search */}
        <form onSubmit={handleSearch} className="flex-1 max-w-xl hidden sm:block">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="Search Rails, Hotwire, PostgreSQL..."
              className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand/30 focus:border-brand"
            />
          </div>
        </form>

        {/* Nav links (desktop) */}
        <nav className="hidden md:flex items-center gap-5 text-sm font-medium text-gray-600 ml-auto">
          <Link href="/episodes" className="hover:text-gray-900">Episodes</Link>
          <Link href="/series" className="hover:text-gray-900">Series</Link>
          <Link href="/pricing" className="hover:text-gray-900">Pricing</Link>
        </nav>

        {/* Auth */}
        <div className="flex items-center gap-2 ml-2 shrink-0">
          {auth.user ? (
            <>
              <Link href="/dashboard" className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 hidden md:flex">
                {auth.user.avatar_url ? (
                  <img src={auth.user.avatar_url} alt={auth.user.name} className="w-7 h-7 rounded-full object-cover" />
                ) : (
                  <span className="w-7 h-7 rounded-full bg-brand text-white text-xs flex items-center justify-center font-semibold">
                    {auth.user.name?.[0]?.toUpperCase() ?? '?'}
                  </span>
                )}
                <span className="hidden md:inline">{auth.user.name?.split(' ')[0]}</span>
              </Link>
              <Link
                href="/users/sign_out"
                method="delete"
                as="button"
                className="text-sm text-gray-500 hover:text-gray-900 hidden md:inline"
              >
                Sign out
              </Link>
            </>
          ) : (
            <>
              <Link href="/users/sign_in" className="text-sm text-gray-600 hover:text-gray-900">
                Sign in
              </Link>
              <Link
                href="/pricing"
                className="px-4 py-1.5 bg-brand text-white text-sm font-medium rounded-full hover:bg-brand-hover transition-colors"
              >
                Start free
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
    <Flash />
  </>
  )
}
